import { ATS_POSITION_VALUES, Badge, CONTRACT_TYPES } from '@cibli/shared';
import { useTranslation } from 'react-i18next';

type ContractTypeBadgeProps = {
  contractType: string;
  variant?: 'default' | 'secondary' | 'outline' | 'destructive';
  className?: string;
};

const LEGACY_CONTRACT_KEYS = new Set(Object.values(CONTRACT_TYPES));
const KNOWN_CONTRACT_KEYS: Set<string> = new Set([...ATS_POSITION_VALUES, ...LEGACY_CONTRACT_KEYS]);

/**
 * Shared component for displaying contract type badges
 * Used in both kiosk (matching) and applicant areas
 * Handles i18n translation automatically
 */
export const ContractTypeBadge = ({ contractType, variant, className }: ContractTypeBadgeProps) => {
  const { t } = useTranslation();
  const key = KNOWN_CONTRACT_KEYS.has(contractType) ? contractType : 'other';

  // Default kiosk styling if no variant provided
  const defaultClassName = variant ? '' : 'bg-gray-200 text-black h-7 rounded-sm';

  return (
    <Badge variant={variant} className={className || defaultClassName}>
      {t(`MatchingJobs.contractType.${key}`)}
    </Badge>
  );
};
